import * as types from '../actions/types';
import * as request from '../utils/request';
import mergeRequestsWrapper from './mergeRequestsWrapper'

export function getSchoolByIdSuccess(school) {
  return {
    type: types.GET_SCHOOL_BY_ID_SUCCESS,
    payload: school
  };
}

export const getSchool = mergeRequestsWrapper(function getSchool(id) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      const path = `/schools/${id}/`;
      request
        .req('GET', path)
        .then(res => {
          dispatch(getSchoolByIdSuccess(res.data));
          return resolve(res.data);
        })
        .catch(err => {
          console.log('err', err);
          return reject();
        });
    });
  };
})



// WEBPACK FOOTER //
// ./src/actions/schoolActionCreators.js